function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './credit-card-form.scss';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import NumberOfInstallments from 'researcher/components/NumberOfInstallments';
import Loading from 'researcher/components/Loading';
import { ALLPAGOCREDITCARD } from 'researcher/domain/transaction/payment-method';
import { Controls } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import { convertedPrice } from 'researcher/helpers/price';
import { paymentMethodReady, requestPaymentMethod, save } from '../actions';
import TaxIdentificationForm from './TaxIdentificationForm';
import AllpagoCreditCardFrame from './AllpagoCreditCardFrame';
var Checkbox = Controls.Checkbox;
export var defaultValues = {
  checkoutId: '',
  createRegistration: false,
  numberOfInstallments: {
    value: null
  }
};
var AllpagoCreditCardForm = function AllpagoCreditCardForm(_ref) {
  var convertTotal = _ref.convertTotal,
    currency = _ref.currency,
    receiptCode = _ref.receiptCode,
    registerPreProcessor = _ref.registerPreProcessor,
    total = _ref.total;
  var methods = useFormContext();
  var _methods$watch = methods.watch(['allpagoCreditCard', 'allpagoCreditCard[numberOfInstallments]', 'paymentMethodId']),
    _methods$watch2 = _slicedToArray(_methods$watch, 3),
    allpagoCreditCard = _methods$watch2[0],
    numberOfInstallments = _methods$watch2[1],
    paymentMethodId = _methods$watch2[2];
  var dispatch = useDispatch();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    checkoutId = _useState2[0],
    setCheckoutId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    creditFrameLoaded = _useState4[0],
    setCreditFrameLoaded = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    displayCreditCardFrame = _useState6[0],
    setDisplayCreditCardFrame = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    formDataState = _useState8[0],
    setFormDataState = _useState8[1];
  useEffect(function () {
    if (checkoutId) {
      setCreditFrameLoaded(true);
      dispatch(paymentMethodReady());
      registerPreProcessor(submitAllpagoData);
    }
  }, [checkoutId]);
  useEffect(function () {
    setDisplayCreditCardFrame(false);
    setCreditFrameLoaded(false);
    setFormDataState({});
  }, [total, numberOfInstallments.value]);
  useEffect(function () {
    if (!displayCreditCardFrame) {
      setDisplayCreditCardFrame(true);
    } else {
      dispatch(requestPaymentMethod());
    }
  }, [displayCreditCardFrame]);
  var submitAllpagoData = function submitAllpagoData(rawData) {
    var data = rawData;

    // We submit our data to allpago after we save the payment. This allows us to create the
    // payment request and query it after it's been created in allpago.
    return new Promise(function (resolve) {
      // Insert our data into the allpago form
      setFormDataState({
        submit: true,
        submittedAt: Date.now(),
        'billing.country': 'BR',
        'billing.state': data.billingAddress.state,
        'billing.city': data.billingAddress.city,
        'billing.postcode': data.billingAddress.zip,
        'billing.street1': data.billingAddress.address1,
        'billing.street2': data.billingAddress.address2,
        'card.holder': data.billingAddress.name,
        createRegistration: data.allpagoCreditCard.createRegistration,
        'customer.merchantCustomerId': data.allpagoCreditCard.taxIdentification.number,
        'recurring.numberOfInstallments': data.allpagoCreditCard.numberOfInstallments.value
      });

      // Insert the checkout id into our form data
      data = _objectSpread(_objectSpread({}, data), {}, {
        allpagoCreditCard: {
          id: checkoutId,
          numberOfInstallments: data.allpagoCreditCard.numberOfInstallments
        }
      });

      // After allpago checkout completes, we're redirected back to megatron
      // The complete action triggers this event listener, to complete our payment
      window.completeAllpagoPayment = function () {
        return resolve(data);
      };
    });
  };
  if (paymentMethodId !== ALLPAGOCREDITCARD) {
    return null;
  }
  var allpagoTotal = convertedPrice({
    exchangeRate: 1 / currency.exchangeRate
  }, total, currency.isoCode !== 'USD' && !convertTotal);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "row credit-card-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(T, {
    source: "Payment information"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(NumberOfInstallments, {
    convertNumberOfInstallments: convertTotal,
    currency: currency,
    total: total
  })), /*#__PURE__*/React.createElement(TaxIdentificationForm, {
    name: "allpagoCreditCard"
  }), allpagoCreditCard.numberOfInstallments.value ? /*#__PURE__*/React.createElement(React.Fragment, null, !creditFrameLoaded ? /*#__PURE__*/React.createElement(Loading, {
    className: "mx-auto"
  }) : null, displayCreditCardFrame ? /*#__PURE__*/React.createElement(AllpagoCreditCardFrame, {
    formData: formDataState,
    numberOfInstallments: allpagoCreditCard.numberOfInstallments.value,
    receiptCode: receiptCode,
    requestSave: function requestSave() {
      return dispatch(save());
    },
    setCheckoutId: setCheckoutId,
    total: allpagoTotal
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: "Save my credit card information",
    name: "allpagoCreditCard[createRegistration]"
  }))) : null));
};
export default AllpagoCreditCardForm;